import i18next from "../../i18n/config";

const initialState = {
  title: null,
  msg: {},
  status: null,
  customBtn: null,
};

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ERRORS":
      return {
        msg: i18next.t(action.payload.msg),
        title: i18next.t(action.payload.title),
        status: action.payload.status,
        customBtn: action.payload.customBtn,
      };
    case "CLEAR_ERRORS":
      return initialState;
    default:
      return state;
  }
};

export const returnErrors = (msg, status, title = "", customBtn) => {
  return {
    type: "GET_ERRORS",
    payload: {msg, status, title, customBtn},
  };
};

export const clearErrors = () => {
  return {
    type: "CLEAR_ERRORS",
  };
};

export default errorReducer;
